import gql from "graphql-tag";
import { BOOKING_FRAGMENT } from '../fragment/booking';

export const NEW_BOOKING_QUOTE = gql`
    mutation getNewBookingQuote($uuid:String!){
        getNewBookingQuote(uuid: $uuid){
            ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;

export const NEW_BOOKING = gql`
    mutation newBooking($currency: String!, $type:String!) {
        newBooking(currency: $currency, type:$type) {
            uuid
            iso_currency
        }
    }
`;

export const ADD_SECTOR = gql`
    mutation addSector($bookingId: String!, $tourId: String!, $type: String!, $to: String!, $nights: Int, $date: String){
        addSector( bookingId: $bookingId, tourId: $tourId, type: $type, to: $to, nights: $nights, date: $date){
          ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;


export const DELETE_SECTOR = gql`
    mutation deleteSector($bookingId: String!, $sectorId: String!){
        deleteSector(bookingId:$bookingId, sectorId:$sectorId){
          ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;


export const ADD_PRODUCT = gql`
    mutation addProduct($bookingId: String!, $tourId: String!, $type: String!, $date: String!, $name: String!){
        addProduct(bookingId: $bookingId, tourId: $tourId, type: $type, date: $date, name: $name){
            ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;

export const UPDATE_SECTOR = gql`
    mutation updateSector($bookingId: String!, $sectorId: Int!, $nights: Int!, $date:String, $update:Boolean) {
        updateSector(bookingId:$bookingId, sectorId: $sectorId, nights: $nights, date:$date, update:$update) {
          ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;


export const UPDATE_SECTOR_ACCOMMODATION = gql`
    mutation updateAccommodation($sectorId:Int!, $propertyType: String!, $reservationType: String!, $roomType: String!, $roomCode: String! $currency:String!){
        updateAccommodation(sectorId:$sectorId, propertyType: $propertyType, reservationType: $reservationType, roomType: $roomType, roomCode:$roomCode, currency:$currency){
          ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;


export const UPDATE_BOOKING_STATUS = gql`
    mutation setBookingStatus($bookingId:String!, $status:String!){
        setBookingStatus(bookingId:$bookingId, status:$status)
    }
`;

export const UPDATE_PRODUCT_SECTOR = gql`
    mutation updateProductSector($bookingId:String!, $sectorId:Int!, $date:String!){
        updateProductSector(bookingId:$bookingId, sectorId:$sectorId, date:$date){
            ...BookingFragment
        }
    }
    ${BOOKING_FRAGMENT}
`;


export const PAY_BOOKING = gql`
    mutation payBooking($tmsBookingId: String!, $paymentType: String!, $currency: String!, $paymentMethod: String!, $reference: String, $paymentReference: String){
        payBooking(tmsBookingId: $tmsBookingId, paymentType: $paymentType, currency: $currency, paymentMethod: $paymentMethod, reference: $reference, paymentReference: $paymentReference)
    }
`;